import "@mantine/core/styles.css";
import "@mantine/dates/styles.css"; // if using Mantine date picker features
import "mantine-react-table/styles.css"; // make sure MRT styles are imported in your app root (once)
import { useEffect, useState, useRef } from "react";
import { useHover } from "@mantine/hooks";
import FiltreComponent from "components/Common/Filtre";
import { useMediaQuery } from "@mantine/hooks";

import {
  MantineReactTable,
  useMantineReactTable,
  MRT_TablePagination,
  MRT_GlobalFilterTextInput,
} from "mantine-react-table";
import Switch from "react-switch";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { MRT_Localization_FR } from "mantine-react-table/locales/fr";
import {
  // Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import config from "config";
import {
  ActionIcon,
  Box,
  Group,
  Button,
  Menu,
  Flex,
  MantineProvider,
  TextInput,
} from "@mantine/core";
import {
  IconColumns,
  IconFilterPlus,
  IconPlus,
  IconSearch,
} from "@tabler/icons-react";
import { Label, Tooltip } from "reactstrap";
import { Tooltip as MantineTooltip } from "@mantine/core";
import { useSelector, useDispatch } from "react-redux";
import {
  setCurrentPageProjets,
  setCustomFilterProjets,
  setPageSizeProjets,
  setValueProjets,
  setSortingProjets,
  setQueryProjets,
  setActifProjets,
  setSelectedOptionFiltersProjets,
  setSelectedOptionIdProjets,
  setColumnProjets,
} from "store/actions";
import LastModificationAlert from "components/Common/Alert";
import DeleteButton from "components/Common/DeleteButtonList";
import { debounce, trim } from "lodash";
import CustomSelect from "../../components/Common/CustomSelect";
import PendingFilters from "components/Common/PendingFIlters";
import ActiveFilters from "components/Common/ActiveFilters";

const ProjetsList = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const backUrl = config.backOffice.url;
  const api = config.backOffice.apiName;
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const { hovered, ref } = useHover();
  const layout = localStorage.getItem("layoutMode");
  const token = localStorage.getItem("auth_token_" + api);

  const isFirstLoad = useRef(true);
  const [modal1, setModal1] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // État pour gérer l'ouverture du menu
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  // Data and fetching state
  const [allData, setAllData] = useState();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  document.title = "Projets | DOM COM";
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [headers, setHeaders] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filtreRef = useRef();
  // Export
  const [downloadUrl, setDownloadUrl] = useState(null);
  const downloadLinkRef = useRef(null);

  const [loading2, setLoading2] = useState(false);
  const downloadFile = async () => {
    setLoading2(true);
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/projets/export?key=${globalFilter}&${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      setDownloadUrl(url);
    } catch (error) {
      console.error("Erreur lors du téléchargement du fichier", error);
    } finally {
      setLoading2(false);
    }
  };

  useEffect(() => {
    if (downloadUrl && downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  }, [downloadUrl]);
  //
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest(".menu-container")) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);
  // Selection et chargement du filtre
  const [load_filter, setLoadfilter] = useState({});
  const handleSelect = async (option) => {
    if (option == null) {
      setLoadfilter("");
      return;
    }

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/preferences_filters/load_filter?id=${option.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "auth_token_" + api
            )}`, // Remplace par ta gestion de token
          },
        }
      );

      if (response.ok) {
        const data = await response.json();

        if (data && data.result) {
          setLoadfilter(data.result);
          toast.success("Filtre chargé avec succès !");
        } else {
          toast.error("Aucun paramètre trouvé pour ce filtre.");
        }
      } else {
        toast.error("Échec du chargement du filtre.");
      }
    } catch (error) {
      console.error("Erreur réseau lors du chargement du filtre :", error);
      toast.error("Erreur réseau. Veuillez réessayer.");
    }
  };
  // Update filters
  const handleSave = async (filterId) => {
    // Vérification des entrées
    if (!filterId || !actif || Object.keys(actif).length === 0) {
      toast.error("Aucun filtre à mettre à jour.");
      return;
    }

    // Fonction helper pour formater la date au format DD/MM/YYYY avec fallback
    const formatDateFR = (dateValue) => {
      try {
        const dateObj = new Date(dateValue);

        if (isNaN(dateObj.getTime())) {
          // Date invalide : utiliser la date actuelle
          const today = new Date();
          return `${today.getDate().toString().padStart(2, "0")}/${(
            today.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}/${today.getFullYear()}`;
        }

        // Date valide : formater en DD/MM/YYYY
        return `${dateObj.getDate().toString().padStart(2, "0")}/${(
          dateObj.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${dateObj.getFullYear()}`;
      } catch (error) {
        // En cas d'erreur, utiliser la date actuelle
        const today = new Date();
        return `${today.getDate().toString().padStart(2, "0")}/${(
          today.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${today.getFullYear()}`;
      }
    };

    // Fonction pour traiter un filtre individuel
    const processFilter = (key, filterObj, acc) => {
      const { value, operator, type } = filterObj;

      if (type === "text") {
        if (operator === "commence par") acc[key + "_like"] = `^${value}`;
        if (operator === "contient") acc[key + "_like"] = `${value}`;
        if (operator === "fini par") acc[key + "_like"] = `${value}$`;
        if (operator === "égale à") acc[key + "_equals"] = `${value}`;
        if (operator === "est vide") acc[key + "_is_null"] = true;
      }

      if (type === "number") {
        if (operator === "supérieur à") acc[key + "_gt"] = `${value}`;
        if (operator === "supérieur ou égal à") acc[key + "_gte"] = `${value}`;
        if (operator === "inférieur à") acc[key + "_lt"] = `${value}`;
        if (operator === "inférieur ou égal à") acc[key + "_lte"] = `${value}`;
        if (operator === "égale à") acc[key + "_equals"] = `${value}`;
        if (operator === "est vide") acc[key + "_is_null"] = true;
      }

      if (type === "select") {
        const selectedValues = Array.isArray(value) ? value : [value];
        acc[key] = selectedValues.join(",");
      }

      if (type === "date") {
        const formattedValue = formatDateFR(value);

        if (operator === "égale à") acc[key + "_equals"] = formattedValue;
        if (operator === "avant") acc[key + "_lt"] = formattedValue;
        if (operator === "après") acc[key + "_gt"] = formattedValue;
        if (operator === "est vide") acc[key + "_is_null"] = true;
        if (operator === "après ou égal à") acc[key + "_gte"] = formattedValue;
        if (operator === "avant ou égal à") acc[key + "_lte"] = formattedValue;
      }

      return acc;
    };

    const filterParams = Object.keys(actif).reduce((acc, key) => {
      const filterValue = actif[key];

      // Gérer le cas où filterValue est un tableau (filtres accumulés)
      if (Array.isArray(filterValue)) {
        // Utiliser une Map pour éviter les doublons de conditions
        const conditionMap = new Map();

        filterValue.forEach((filter) => {
          const { operator, type } = filter;
          let conditionKey;

          // Générer une clé unique pour chaque type de condition
          if (type === "text") {
            if (operator === "commence par") conditionKey = `${key}_like_start`;
            if (operator === "contient") conditionKey = `${key}_like`;
            if (operator === "fini par") conditionKey = `${key}_like_end`;
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
          }

          if (type === "number") {
            if (operator === "supérieur à") conditionKey = `${key}_gt`;
            if (operator === "supérieur ou égal à") conditionKey = `${key}_gte`;
            if (operator === "inférieur à") conditionKey = `${key}_lt`;
            if (operator === "inférieur ou égal à") conditionKey = `${key}_lte`;
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
          }

          if (type === "select") {
            conditionKey = `${key}`;
          }

          if (type === "date") {
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "avant") conditionKey = `${key}_lt`;
            if (operator === "après") conditionKey = `${key}_gt`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
            if (operator === "après ou égal à") conditionKey = `${key}_gte`;
            if (operator === "avant ou égal à") conditionKey = `${key}_lte`;
          }

          // Stocker le dernier filtre pour cette condition (remplace si existe)
          if (conditionKey) {
            conditionMap.set(conditionKey, filter);
          }
        });

        // Traiter chaque filtre unique
        conditionMap.forEach((filter) => {
          processFilter(key, filter, acc);
        });
      } else {
        // Gérer le cas où filterValue est un objet simple (rétrocompatibilité)
        processFilter(key, filterValue, acc);
      }

      return acc;
    }, {});

    const payload = {
      id: filterId.value,
      filter_params: filterParams,
    };

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/preferences_filters/update_filter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log("Filtre mis à jour avec succès:", result);
        toast.success("Le filtre a été mis à jour avec succès !");
      } else {
        console.error(
          "Erreur lors de la mise à jour du filtre:",
          response.statusText
        );
        toast.error("La mise à jour du filtre a échoué.");
      }
    } catch (error) {
      console.error("Erreur réseau lors de la mise à jour du filtre:", error);
      toast.error(
        "Erreur réseau lors de la mise à jour du filtre. Veuillez réessayer."
      );
    }
  };
  const handleEdit = (option) => {
    console.log(`Editing: ${option.value}`);
  };

  const handleDelete = async (option) => {
    if (!option.value) {
      toast.error("Aucun filtre sélectionné à supprimer");
      return;
    }

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/preferences_filters/destroy_filter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "auth_token_" + api
            )}`,
          },
          body: JSON.stringify({ id: option.value }),
        }
      );

      if (response.ok) {
        toast.success("Filtre supprimé avec succès !");
        await getListFilter();
      } else {
        console.error(
          "Erreur lors de la suppression du filtre:",
          response.statusText
        );
        alert("Échec de la suppression du filtre.");
      }
    } catch (error) {
      console.error("Erreur réseau lors de la suppression du filtre:", error);
      alert("Erreur réseau. Veuillez réessayer.");
    }
  };

  const [options, setOptions] = useState([]);
  const getListFilter = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/preferences_filters/list_filters?controlleur=projets`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setOptions(data.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getListFilter();
  }, []);
  const [columnVisibility, setColumnVisibility] = useState([]);
  const [columns, setColumns] = useState([]);
  const sorted = useSelector((state) => state.FiltreProjets.sorting);
  const query = useSelector((state) => state.FiltreProjets.query);
  const actif = useSelector((state) => state.FiltreProjets.actif);
  const selectedOptionFilters = useSelector(
    (state) => state.FiltreProjets.selectedOptionFilters
  );
  const selectedOptionId = useSelector(
    (state) => state.FiltreProjets.selectedOptionId
  );
  const [sorting, setSorting] = useState(sorted);
  const currentPage = useSelector((state) => state.FiltreProjets.currentPage);
  const pageSize = useSelector((state) => state.FiltreProjets.pageSize);
  const value = useSelector((state) => state.FiltreProjets.value);
  const customFilters = useSelector((state) => state.FiltreProjets.customFilters);
  const [columnFilters, setColumnFilters] = useState(customFilters);
  const debouncedSetColumnFilters = debounce((newFilters) => {
    setColumnFilters(newFilters);
  }, 1000);
  const [globalFilter, setGlobalFilter] = useState(value);
  // État pour la valeur saisie (différent du globalFilter appliqué)
  const [searchInputValue, setSearchInputValue] = useState(value || "");
  useEffect(() => {
    setSearchInputValue(globalFilter || "");
  }, [globalFilter]);
  const debouncedSetGlobalFilter = debounce((newFilter) => {
    setGlobalFilter(newFilter);
  }, 1000);
  const [pagination, setPagination] = useState({
    pageIndex: currentPage,
    pageSize: "",
  });
  //nouveaux états pour les filtres
  const [pendingFilters, setPendingFilters] = useState([]);
  const [filters, setFilters] = useState(actif);

  const handleApplyPendingFilters = () => {
    const newFilters = { ...filters };
    const operatorMap = {
      "Commence par": "commence par",
      Contient: "contient",
      "Fini par": "fini par",
      Égale: "égale à",
      Avant: "avant",
      Après: "après",
      "Supérieur à": "supérieur à",
      "Inférieur à": "inférieur à",
      select: "select",
      "Est vide": "est vide",
      "Supérieur ou égal à": "supérieur ou égal à",
      "Inférieur ou égal à": "inférieur ou égal à",
      "Avant ou égal à": "avant ou égal à",
      "Après ou égal à": "après ou égal à",
    };

    pendingFilters.forEach(({ column, condition, value }) => {
      try {
        // Trouver la colonne correspondante
        const foundColumn = columns.find((col) => col.accessorKey === column);

        // Vérifier si la colonne existe
        if (!foundColumn) {
          throw new Error(
            `the column "${column}" does not exist or is not displayed in the configuration`
          );
        }

        // Vérifier si le type est défini
        if (!foundColumn.type) {
          throw new Error(`the type of the column "${column}" is not defined`);
        }

        const newFilter = {
          type: foundColumn.type,
          operator: operatorMap[condition],
          value,
        };

        if (newFilters[column]) {
          if (Array.isArray(newFilters[column])) {
            // Chercher si une condition identique existe déjà
            const existingIndex = newFilters[column].findIndex(
              (filter) => filter.operator === newFilter.operator
            );

            if (existingIndex !== -1) {
              // Remplacer l'ancien filtre par le nouveau
              newFilters[column][existingIndex] = newFilter;
            } else {
              // Ajouter le nouveau filtre (condition différente)
              newFilters[column].push(newFilter);
            }
          } else {
            // Si c'est un objet simple, vérifier la condition
            if (newFilters[column].operator === newFilter.operator) {
              // Remplacer directement (même condition)
              newFilters[column] = newFilter;
            } else {
              // Transformer en tableau avec l'ancien et le nouveau filtre
              newFilters[column] = [newFilters[column], newFilter];
            }
          }
        } else {
          // Nouvelle colonne, créer un nouveau filtre
          newFilters[column] = newFilter;
        }
      } catch (error) {
        // Afficher l'alerte avec toast (react-toastify)
        toast.error(`Error applying filter: ${error.message}`);
      }
    });

    setFilters(newFilters);
    setPendingFilters([]);
  };
  const handleRemovePendingFilter = (index) => {
    setPendingFilters((prev) => prev.filter((_, i) => i !== index));
  };
  const handleRemoveFilter = (column, index = null) => {
    setFilters((prev) => {
      const newFilters = { ...prev };

      if (index !== null && Array.isArray(newFilters[column])) {
        // Supprimer un filtre spécifique dans un tableau
        const updatedArray = newFilters[column].filter((_, i) => i !== index);

        if (updatedArray.length === 0) {
          // Si plus de filtres pour cette colonne, supprimer la clé
          delete newFilters[column];
        } else if (updatedArray.length === 1) {
          // Si un seul filtre reste, le convertir en objet simple
          newFilters[column] = updatedArray[0];
        } else {
          // Sinon, garder le tableau
          newFilters[column] = updatedArray;
        }
      } else {
        // Supprimer toute la colonne (comportement original)
        delete newFilters[column];
      }

      return newFilters;
    });
  };
  ////
  const url = new URL(`/${api}/projets`, "https://www.fluxod.com");
  //column pinning
  const [columnPinning, setColumnPinning] = useState({ left: [], right: [] });
  // console.log(columnPinning)
  const handleColumnPinningChange = async (newColumnPinning) => {
    setColumnPinning(newColumnPinning);
  };

  useEffect(() => {
    if (!isPageLoaded) {
      return;
    }
    try {
      const response = fetch(
        `https://www.fluxod.com/${api}/preferences_lists/set_pinned_columns`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            controlleur: "projets",
            pinned_columns: columnPinning,
          }),
        }
      );

      if (!response.ok) {
        console.log(response);
      }

      // return response.json()
    } catch (error) {
      console.error("There was a problem with the POST request:", error);
      // You can handle errors here, such as displaying an error message to the user
      throw error; // Rethrow the error to handle it further if needed
    }
  }, [columnPinning]);
  const [columnSizing, setColumnSizing] = useState({
    "mrt-row-actions": "110",
  });

  const handleColumnSizingChange = (newColumnSize) => {
    setColumnSizing(newColumnSize);
  };
  useEffect(() => {
    if (!isPageLoaded) {
      return;
    }
    try {
      const response = fetch(
        `https://www.fluxod.com/${api}/preferences_lists/set_size_columns`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            controlleur: "projets",
            size_columns: columnSizing,
          }),
        }
      );

      if (!response.ok) {
        console.log(response);
      }

      // return response.json()
    } catch (error) {
      console.error("There was a problem with the POST request:", error);
      // You can handle errors here, such as displaying an error message to the user
      throw error; // Rethrow the error to handle it further if needed
    }
  }, [columnSizing]);

  // Fetch data when dependencies change
  useEffect(() => {
    setIsPageLoaded(false);

    if (isFirstLoad.current || isPageLoaded) {
      const fetchData = async () => {
        if (!data.length) {
          setIsLoading(true);
        } else {
          setIsRefetching(true);
        }

        const url = new URL(`/${api}/projets`, "https://www.fluxod.com");
        url.searchParams.set("page", `${pagination.pageIndex + 1}`);
        if (pagination.pageSize == "") {
          console.log("do nothing..;");
        } else {
          url.searchParams.set("limit", `${pagination.pageSize}`);
        }

        const decodedString = decodeURIComponent(JSON.stringify(sorting));
        const obj = JSON.parse(decodedString);

        const id = obj[0]?.id || "";
        let order = obj[0]?.desc || "";
        if (order === true) {
          order = "_desc";
        } else {
          order = "_asc";
        }
        if (id === "") {
          order = "";
        }
        url.searchParams.set("key", globalFilter ?? "");
        url.searchParams.set("sort_by", id + order);
        dispatch(setSortingProjets(sorting));
        const formatDateForRequest = (date) => {
          if (!date) {
            console.log("Date object is null or empty:", date);
            return null;
          }
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          console.log("Formatted Date:", year, month, day);
          return `${year}-${month}-${day}`;
        };

        const columnsWithFilter = columns.filter(
          (item) => item.filterVariant === "date-range"
        );

        const ids = columnsWithFilter.map((item) => item.id);
        columnFilters.forEach((filter) => {
          const { id, value } = filter;
          if (ids.includes(id) && value) {
            const [min, max] = value;
            if (min) {
              url.searchParams.set(
                `${id}_min`,
                formatDateForRequest(new Date(min))
              );
            }
            if (max) {
              url.searchParams.set(
                `${id}_max`,
                formatDateForRequest(new Date(max))
              );
            }
          } else {
            url.searchParams.set(id, value);
          }
        });

        try {
          const response = await fetch(url.href + `&${query}`, {
            method: "GET",

            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          if (response.ok) {
            const json = await response.json();
            // localStorage.setItem("columnOrder", json.order_columns.split(","))
            const transformKeys = (jsonArray) => {
              return jsonArray.map((obj) => {
                const newObj = {};
                Object.keys(obj).forEach((key) => {
                  newObj[key] = obj[key];
                });
                return newObj;
              });
            };
            setPagination((prevPagination) => ({
              ...prevPagination,
              pageSize: json.per_page,
            }));

            dispatch(setCurrentPageProjets(pagination.pageIndex));
            dispatch(setPageSizeProjets(pagination.pageSize));
            dispatch(setValueProjets(globalFilter));
            dispatch(setCustomFilterProjets(columnFilters));
            const updateTransactionDateColumn = (columns) => {
              return columns.map((column) => {
                // Common Header Configuration
                const headerStyle = {
                  whiteSpace: "nowrap", // Prevent text wrapping
                  overflow: "hidden", // Hide overflow text
                  textOverflow: "ellipsis", // Add ellipsis if text overflows
                };

                const headerTitle = column.header; // Tooltip text from header

                if (column.filterVariant === "date-range") {
                  return {
                    ...column,
                    accessorFn: (row) => {
                      const dateStr = row?.[column.accessorKey];
                      if (!dateStr) return null;
                      const [day, month, year] = dateStr.split("/");
                      return `${day}/${month}/${year}`;
                    },
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != ""
                          ? cell?.getValue()
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "compte") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <Link
                        to={`${backUrl}/comptes/${row.original.compte_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#ef7918",
                          }}
                        >
                          {cell.getValue()}
                        </span>
                      </Link>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.formatAmount) {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "right",
                          display: "block",
                          width: "100%",
                          fontFamily: "sans-serif",
                        }}
                      >
                        {cell?.getValue() != null
                          ? (Math.round(cell?.getValue() * 100) / 100) // Arrondi à 2 chiffres après la virgule
                              .toLocaleString("fr-FR", {
                                style: "currency",
                                currency: "EUR",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              .replace("€", "")
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "statut_investisseur" ||
                  column.accessorKey === "statuts_souscription" ||
                  column.accessorKey === "statut_pme" ||
                  column.accessorKey === "statut_projet"
                ) {
                  return {
                    ...column,

                    Cell: ({ cell }) => (
                      <span
                        className={
                          cell.getValue() === "En attente" ||
                          cell.getValue() === "Commercialisation"
                            ? "bg-info badge bg-secondary"
                            : cell.getValue() === "Cloturée" ||
                              cell.getValue() === "Radiée"
                            ? "badge-soft-danger badge bg-secondary"
                            : cell.getValue() === "En cours"
                            ? "bg-info badge bg-secondary"
                            : cell.getValue() == "Validé" ||
                              cell.getValue() == "Validée"
                            ? "bg-success badge bg-secondary"
                            : null
                        }
                        style={{ fontSize: 12 }}
                      >
                        {cell.getValue()}
                      </span>
                    ),

                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "courrier" ||
                  column.accessorKey === "compte_ouvert"
                ) {
                  return {
                    ...column,

                    Cell: ({ cell }) => (
                      <span
                        className={
                          cell.getValue() === "Non"
                            ? "badge-soft-danger badge bg-secondary"
                            : cell.getValue() == "Oui"
                            ? "bg-success badge bg-secondary"
                            : null
                        }
                        style={{ fontSize: 12 }}
                      >
                        {cell.getValue()}
                      </span>
                    ),

                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "fichier" ||
                  column.accessorKey === "rapport"
                ) {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "center",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell.getValue() != null ? (
                          <a
                            href={cell.getValue()}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#73a9ff", fontSize: 20 }}
                          >
                            <i className="mdi mdi-download"></i>
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "nb_lignes_created" ||
                  column.accessorKey === "nb_lignes_updated"
                ) {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "right",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null
                          ? (Math.floor(cell?.getValue() * 10000) / 10000)
                              .toLocaleString("fr-FR", {
                                style: "currency",
                                currency: "EUR",
                                minimumFractionDigits: 0, // Définit un minimum de 4 chiffres après la virgule
                                maximumFractionDigits: 4, // Définit un maximum élevé pour éviter l'arrondissement automatique
                              })
                              .replace("€", "")
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "partenaire") {
                  return {
                    ...column,
                    Cell: ({ cell, row }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != "" ? (
                          <Link
                            to={`http://www.fluxod.com/${api}/partenaires/${row.original.partenaire_id}/redirect_to_real_controller`}
                            style={{ textDecoration: "none" }}
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#555B21",
                              }}
                            >
                              {cell.getValue()}
                            </span>
                          </Link>
                        ) : (
                          "--"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "entity") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != "" ? (
                          <Link
                            to={`${backUrl}/entities/${row.original.entity_id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#555B21",
                              }}
                            >
                              {cell.getValue()}
                            </span>
                          </Link>
                        ) : (
                          "--"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "asset_account") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != "" ? (
                          <Link
                            to={`${backUrl}/asset_accounts/${row.original.asset_account_id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#555B21",
                              }}
                            >
                              {cell.getValue()}
                            </span>
                          </Link>
                        ) : (
                          "--"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "currency") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <Link
                        to={`${backUrl}/currencies/${row.original.currency_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#555B21",
                          }}
                        >
                          {cell?.getValue() != null && cell.getValue() != ""
                            ? cell?.getValue()
                            : "--"}
                        </span>
                      </Link>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "bank_account") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <Link
                        to={`${backUrl}/bank_accounts/${row.original.bank_account_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#555B21",
                          }}
                        >
                          {cell.getValue()}
                        </span>
                      </Link>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null &&
                        cell.getValue() != "" &&
                        cell.getValue() != "null"
                          ? cell?.getValue()
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                }
              });
            };
            setAllData(json);

            setHeaders(
              transformKeys(updateTransactionDateColumn(json.headers))
            );
            setData(json.data);
            setRowCount(json.total_records);
            // setColumnPinning(json.pinned_columns)
            // setColumnSizing(json.size_columns)
            // const lastUnderscoreIndex = json.sort_by.lastIndexOf("_")

            // Filter the columns to show only those with visible === true
            const visibleColumns = json.headers.filter((col) => col.visible);
            setColumnVisibility(json.headers.map((col) => col.visible));
            setColumns(json.headers);
            dispatch(setColumnProjets(json.headers));
            setColumnOrder(json.order_columns.split(","));

            // console.log(json.order_columns.split(","))
          }
          if (response.status === 401) {
            navigate(`${backUrl}/logout`);
          }
          if (response.status === 403) {
            navigate(`${backUrl}/forbidden`);
          }
          if (response.status === 500) {
            navigate(`${backUrl}/error`);
          }
          if (response.status === 203) {
            navigate(`${backUrl}/error404`);
          }
        } catch (error) {
          setIsError(true);
          console.error(error);
          return;
        } finally {
          setIsError(false);
          setIsLoading(false);
          setIsRefetching(false);
          setTimeout(() => {
            setIsPageLoaded(true);
          }, 500);
        }
      };
      fetchData();
      isFirstLoad.current = false;
      if (localStorage.getItem("key") === "true") {
        toast.success("Mise à jour réussie");
        localStorage.setItem("key", "false");
      }
    }
  }, [
    pagination.pageIndex, // refetch when page index changes
    pagination.pageSize, // refetch when page size changes
  ]);
  useEffect(() => {
    setIsPageLoaded(false);

    if (isFirstLoad.current || isPageLoaded) {
      const fetchData = async () => {
        if (!data.length) {
          setIsLoading(true);
        } else {
          setIsRefetching(true);
        }

        const url = new URL(`/${api}/projets`, "https://www.fluxod.com");
        url.searchParams.set("page", `${1}`);
        if (pagination.pageSize == "") {
          console.log("do nothing..;");
        } else {
          url.searchParams.set("limit", `${pagination.pageSize}`);
        }

        const decodedString = decodeURIComponent(JSON.stringify(sorting));
        const obj = JSON.parse(decodedString);

        const id = obj[0]?.id || "";
        let order = obj[0]?.desc || "";
        if (order === true) {
          order = "_desc";
        } else {
          order = "_asc";
        }
        if (id === "") {
          order = "";
        }
        url.searchParams.set("key", globalFilter ?? "");
        url.searchParams.set("sort_by", id + order);
        dispatch(setSortingProjets(sorting));
        const formatDateForRequest = (date) => {
          if (!date) {
            console.log("Date object is null or empty:", date);
            return null;
          }
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          console.log("Formatted Date:", year, month, day);
          return `${year}-${month}-${day}`;
        };

        const columnsWithFilter = columns.filter(
          (item) => item.filterVariant === "date-range"
        );

        const ids = columnsWithFilter.map((item) => item.id);
        columnFilters.forEach((filter) => {
          const { id, value } = filter;
          if (ids.includes(id) && value) {
            const [min, max] = value;
            if (min) {
              url.searchParams.set(
                `${id}_min`,
                formatDateForRequest(new Date(min))
              );
            }
            if (max) {
              url.searchParams.set(
                `${id}_max`,
                formatDateForRequest(new Date(max))
              );
            }
          } else {
            url.searchParams.set(id, value);
          }
        });

        try {
          const response = await fetch(url.href + `&${query}`, {
            method: "GET",

            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          if (response.ok) {
            const json = await response.json();
            // localStorage.setItem("columnOrder", json.order_columns.split(","))
            const transformKeys = (jsonArray) => {
              return jsonArray.map((obj) => {
                const newObj = {};
                Object.keys(obj).forEach((key) => {
                  newObj[key] = obj[key];
                });
                return newObj;
              });
            };
            setPagination((prevPagination) => ({
              pageIndex: 0,
              pageSize: json.per_page,
            }));

            dispatch(setCurrentPageProjets(0));
            dispatch(setPageSizeProjets(pagination.pageSize));
            dispatch(setValueProjets(globalFilter));
            dispatch(setCustomFilterProjets(columnFilters));
            const updateTransactionDateColumn = (columns) => {
              return columns.map((column) => {
                // Common Header Configuration
                const headerStyle = {
                  whiteSpace: "nowrap", // Prevent text wrapping
                  overflow: "hidden", // Hide overflow text
                  textOverflow: "ellipsis", // Add ellipsis if text overflows
                };

                const headerTitle = column.header; // Tooltip text from header

                if (column.filterVariant === "date-range") {
                  return {
                    ...column,
                    accessorFn: (row) => {
                      const dateStr = row?.[column.accessorKey];
                      if (!dateStr) return null;
                      const [day, month, year] = dateStr.split("/");
                      return `${day}/${month}/${year}`;
                    },
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != ""
                          ? cell?.getValue()
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "compte") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <Link
                        to={`${backUrl}/comptes/${row.original.compte_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#ef7918",
                          }}
                        >
                          {cell.getValue()}
                        </span>
                      </Link>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.formatAmount) {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "right",
                          display: "block",
                          width: "100%",
                          fontFamily: "sans-serif",
                        }}
                      >
                        {cell?.getValue() != null
                          ? (Math.round(cell?.getValue() * 100) / 100) // Arrondi à 2 chiffres après la virgule
                              .toLocaleString("fr-FR", {
                                style: "currency",
                                currency: "EUR",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              .replace("€", "")
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "statut_investisseur" ||
                  column.accessorKey === "statuts_souscription" ||
                  column.accessorKey === "statut_pme" ||
                  column.accessorKey === "statut_projet"
                ) {
                  return {
                    ...column,

                    Cell: ({ cell }) => (
                      <span
                        className={
                          cell.getValue() === "En attente" ||
                          cell.getValue() === "Commercialisation"
                            ? "bg-info badge bg-secondary"
                            : cell.getValue() === "Cloturée" ||
                              cell.getValue() === "Radiée"
                            ? "badge-soft-danger badge bg-secondary"
                            : cell.getValue() === "En cours"
                            ? "bg-info badge bg-secondary"
                            : cell.getValue() == "Validé" ||
                              cell.getValue() == "Validée"
                            ? "bg-success badge bg-secondary"
                            : null
                        }
                        style={{ fontSize: 12 }}
                      >
                        {cell.getValue()}
                      </span>
                    ),

                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "courrier" ||
                  column.accessorKey === "compte_ouvert"
                ) {
                  return {
                    ...column,

                    Cell: ({ cell }) => (
                      <span
                        className={
                          cell.getValue() === "Non"
                            ? "badge-soft-danger badge bg-secondary"
                            : cell.getValue() == "Oui"
                            ? "bg-success badge bg-secondary"
                            : null
                        }
                        style={{ fontSize: 12 }}
                      >
                        {cell.getValue()}
                      </span>
                    ),

                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "fichier" ||
                  column.accessorKey === "rapport"
                ) {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "center",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell.getValue() != null ? (
                          <a
                            href={cell.getValue()}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#73a9ff", fontSize: 20 }}
                          >
                            <i className="mdi mdi-download"></i>
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (
                  column.accessorKey === "nb_lignes_created" ||
                  column.accessorKey === "nb_lignes_updated"
                ) {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "right",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null
                          ? (Math.floor(cell?.getValue() * 10000) / 10000)
                              .toLocaleString("fr-FR", {
                                style: "currency",
                                currency: "EUR",
                                minimumFractionDigits: 0, // Définit un minimum de 4 chiffres après la virgule
                                maximumFractionDigits: 4, // Définit un maximum élevé pour éviter l'arrondissement automatique
                              })
                              .replace("€", "")
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "partenaire") {
                  return {
                    ...column,
                    Cell: ({ cell, row }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != "" ? (
                          <Link
                            to={`http://www.fluxod.com/${api}/partenaires/${row.original.partenaire_id}/redirect_to_real_controller`}
                            style={{ textDecoration: "none" }}
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#555B21",
                              }}
                            >
                              {cell.getValue()}
                            </span>
                          </Link>
                        ) : (
                          "--"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "entity") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != "" ? (
                          <Link
                            to={`${backUrl}/entities/${row.original.entity_id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#555B21",
                              }}
                            >
                              {cell.getValue()}
                            </span>
                          </Link>
                        ) : (
                          "--"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "asset_account") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null && cell.getValue() != "" ? (
                          <Link
                            to={`${backUrl}/asset_accounts/${row.original.asset_account_id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#555B21",
                              }}
                            >
                              {cell.getValue()}
                            </span>
                          </Link>
                        ) : (
                          "--"
                        )}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "currency") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <Link
                        to={`${backUrl}/currencies/${row.original.currency_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#555B21",
                          }}
                        >
                          {cell?.getValue() != null && cell.getValue() != ""
                            ? cell?.getValue()
                            : "--"}
                        </span>
                      </Link>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else if (column.accessorKey === "bank_account") {
                  return {
                    ...column,

                    Cell: ({ row, cell }) => (
                      <Link
                        to={`${backUrl}/bank_accounts/${row.original.bank_account_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#555B21",
                          }}
                        >
                          {cell.getValue()}
                        </span>
                      </Link>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                } else {
                  return {
                    ...column,
                    Cell: ({ cell }) => (
                      <span
                        style={{
                          textAlign: "left",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {cell?.getValue() != null &&
                        cell.getValue() != "" &&
                        cell.getValue() != "null"
                          ? cell?.getValue()
                          : "--"}
                      </span>
                    ),
                    Header: () => {
                      const { hovered, ref } = useHover();
                      const generateValidId = (text) => {
                        return text.replace(/[^a-zA-Z0-9-_]/g, ""); // Remplace les caractères invalides
                      };
                      return (
                        <>
                          {" "}
                          {hovered ? (
                            <Tooltip
                              placement="top"
                              isOpen={true}
                              target={generateValidId(headerTitle)}
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                backgroundColor: "black",
                              }}
                            >
                              {headerTitle}
                            </Tooltip>
                          ) : null}{" "}
                          <div ref={ref} id={generateValidId(headerTitle)}>
                            <span style={headerStyle}>{headerTitle}</span>
                          </div>
                        </>
                      );
                    },
                  };
                }
              });
            };
            setAllData(json);

            setHeaders(
              transformKeys(updateTransactionDateColumn(json.headers))
            );
            setData(json.data);
            setRowCount(json.total_records);
            // setColumnPinning(json.pinned_columns)
            // setColumnSizing(json.size_columns)
            const lastUnderscoreIndex = json.sort_by.lastIndexOf("_");

            // Filter the columns to show only those with visible === true
            const visibleColumns = json.headers.filter((col) => col.visible);
            setColumnVisibility(json.headers.map((col) => col.visible));
            setColumns(json.headers);
            setColumnOrder(json.order_columns.split(","));

            // console.log(json.order_columns.split(","))
          }
          if (response.status === 401) {
            navigate(`${backUrl}/logout`);
          }
          if (response.status === 403) {
            navigate(`${backUrl}/forbidden`);
          }
          if (response.status === 500) {
            navigate(`${backUrl}/error`);
          }
          if (response.status === 203) {
            navigate(`${backUrl}/error404`);
          }
        } catch (error) {
          setIsError(true);
          console.error(error);
          return;
        } finally {
          setIsError(false);
          setIsLoading(false);
          setIsRefetching(false);
          setTimeout(() => {
            setIsPageLoaded(true);
          }, 500);
        }
      };
      fetchData();
      isFirstLoad.current = false;
      if (localStorage.getItem("key") === "true") {
        toast.success("Mise à jour réussie");
        localStorage.setItem("key", "false");
      }
    }
  }, [
    columnFilters, // refetch when column filters change
    globalFilter, // refetch when global filter changes
    // pagination.pageIndex, // refetch when page index changes
    // pagination.pageSize, // refetch when page size changes
    query,
    sorting, // refetch when sorting changes
    modal1,
  ]);

  const toggleColumnVisibility = (index) => {
    const updatedColumnVisibility = [...columnVisibility];
    updatedColumnVisibility[index] = !updatedColumnVisibility[index];
    setColumnVisibility(updatedColumnVisibility);

    const updatedHeaders = headers.map((col, i) => ({
      ...col,
      visible: updatedColumnVisibility[i],
    }));
    setHeaders(updatedHeaders);

    const visibleColumns = updatedHeaders.filter((col) => col.visible);
    const token = localStorage.getItem("auth_token_" + api);

    try {
      const response = fetch(
        `https://www.fluxod.com/${api}/preferences_lists/set_visibile_columns`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            controlleur: "projets",
            visibile_columns: visibleColumns
              .map((item) => item.accessorKey)
              .join(", "),
          }),
        }
      );

      if (!response.ok) {
        console.log(response);
      }

      // return response.json()
    } catch (error) {
      console.error("There was a problem with the POST request:", error);
      // You can handle errors here, such as displaying an error message to the user
      throw error; // Rethrow the error to handle it further if needed
    }
  };

  const [columnOrder, setColumnOrder] = useState([]);
  const updateColumnOrder = async (newColumnOrder) => {
    if (!isPageLoaded) {
      return;
    }
    setColumnOrder(newColumnOrder);
    // console.log("Column order updated: ", newColumnOrder.join(","))

    const columnOrderString = newColumnOrder.join(",");
    // localStorage.setItem("columnOrder", columnOrderString)

    const token = localStorage.getItem("auth_token_" + api);
    if (!token) {
      console.error("No token found in localStorage");
      return;
    }

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/preferences_lists/set_order_columns`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            controlleur: "projets",
            order_columns: columnOrderString,
          }),
        }
      );

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error(
          "Failed to update column order:",
          response.status,
          errorMessage
        );
        return;
      }

      const responseData = await response.json();
      // console.log("Column order successfully updated on server:", responseData)
    } catch (error) {
      console.error("There was a problem with the POST request:", error);
      // Optionally, handle the error further, such as displaying an error message to the user
    }
  };

  const table = useMantineReactTable({
    columns: headers.filter((col) => col.visible),
    data,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: columnFilters.length > 0 ? true : false,
      showGlobalFilter: true,
      density: "xs",
    },
    enableFullScreenToggle: false,
    manualFiltering: true,
    manualPagination: true,
    autoResetPageIndex: true,
    manualSorting: true,
    rowCount,
    enableColumnOrdering: true,
    enableFacetedValues: true,
    enableRowActions: true,
    enableColumnResizing: true,
    columnResizeMode: "onEnd",
    displayColumnDefOptions: {
      "mrt-row-actions": {
        enableColumnActions: true,
        grow: false,
        size: "150",
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Flex gap="sm" align="start" direction="column" style={{ paddingTop: 0 }}>
        {/* Titre "" */}
        <h5 style={{ paddingTop: 14, color: "#555B21", margin: 0 }}>
          Projets ({rowCount})
        </h5>

        {/* Ligne avec le menu déroulant et les boutons */}
        <Flex
          gap="sm"
          align="center"
          direction="row"
          wrap="nowrap"
          style={{ width: "100%" }}
        >
          {/* Menu déroulant "Filtre Enregistré" - 290px fixe */}
          <div style={{ height: 32, width: 290, flexShrink: 0 }}>
            <CustomSelect
              options={options}
              onEdit={handleEdit}
              onDelete={handleDelete}
              getFilters={getListFilter}
              onLoad={handleSelect}
              onUpdate={handleSave}
              setSelectedFilter={setSelectedOptionFiltersProjets}
              selectedFilter={selectedOptionFilters}
              selectedOptionId={selectedOptionId}
              setSelectedOptionId={setSelectedOptionIdProjets}
            />
          </div>

          {/* Bouton "Enregistrer" */}
          {!filters || Object.keys(filters).length === 0 ? null : (
            <div style={{ flexShrink: 0 }}>
              <MantineTooltip
                label="Save new filter"
                withArrow
                position="top"
                withinPortal
              >
                <IconFilterPlus
                  color="green"
                  style={{
                    cursor: "pointer",
                    color: "#0a489b",
                    fontSize: "24px",
                  }}
                  onClick={() => {
                    openModal();
                  }}
                />
              </MantineTooltip>
            </div>
          )}
          {/* FiltreComponent */}
          <div
            style={{
              display: "flex",
              flexDirection: "row", // aligne sur l’axe horizontal
              alignItems: "center", // optionnel : aligne en haut
              gap: "11px", // espace entre les deux composants
              width: "100%", // prend toute la largeur
            }}
          >
            <FiltreComponent
              pendingFilters={pendingFilters}
              setPendingFilters={setPendingFilters}
              filters={filters}
              setFilters={setFilters}
              nomControlleur="projets"
              ref={filtreRef}
              columns={headers}
              data={data}
              table={table}
              api={url}
              setData={setData}
              pagination={pagination}
              setQuery={setQueryProjets}
              actif={actif}
              setActif={setActifProjets}
              getFilters={getListFilter}
              isModalOpen={isModalOpen}
              setIsModalOpen={setModalOpen}
              openModal={openModal}
              closeModal={closeModal}
              load_filters={load_filter}
              setSelectedOptionFilters={setSelectedOptionFiltersProjets}
              setSelectedOptionId={setSelectedOptionIdProjets}
            />
            <PendingFilters
              pendingFilters={pendingFilters}
              columns={headers}
              onRemove={handleRemovePendingFilter}
              onApply={handleApplyPendingFilters}
            />
          </div>

          {/* Section des filtres actifs */}
        </Flex>
        <ActiveFilters
          filters={filters}
          columns={headers}
          handleRemoveFilter={handleRemoveFilter}
        />
      </Flex>
    ),
    renderBottomToolbarCustomActions: ({ table }) => (
      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <MRT_TablePagination table={table} />
      </div>
    ),

    renderToolbarInternalActions: ({ table, column }) => (
      <>
        <Flex
          direction="column"
          gap="1"
          align="flex-end"
          style={{ paddingTop: "4.5vh" }}
        >
          {/* Section Filtre */}

          {/* Section Colonnes et Ajouter */}
          <Flex
            justify="flex-end"
            align="center"
            gap="sm"
            style={{ width: "100%", flexWrap: "nowrap" }} // Assure l'alignement à droite et empêche le retour à la ligne
          >
            {/* Section Global Filter */}
            <Box style={{ position: "relative", width: "200px" }}>
              {/* Section Global Filter avec bouton de recherche */}

              <Box style={{ position: "relative", width: "200px" }}>
                <MantineTooltip
                  label="Taper pour rechercher, appuyer sur Entrée pour valider"
                  withArrow
                  position="top"
                  withinPortal
                >
                  <TextInput
                    value={searchInputValue}
                    onChange={(e) => setSearchInputValue(e.target.value)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        // Déclencher la recherche manuellement - CORRIGÉ
                        setGlobalFilter(searchInputValue);
                      }
                    }}
                    placeholder="Rechercher..."
                    style={{
                      width: "200px",
                      paddingRight: "35px",
                    }}
                  />
                </MantineTooltip>
                <MantineTooltip
                  label="Lancer la recherche"
                  withArrow
                  position="top"
                  withinPortal
                >
                  <ActionIcon
                    onClick={() => {
                      // Appliquer le filtre saisi - CORRIGÉ
                      setGlobalFilter(searchInputValue);
                    }}
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                      backgroundColor: "transparent",
                    }}
                    size="sm"
                    variant="transparent"
                  >
                    <IconSearch size={16} color="#868e96" />
                  </ActionIcon>
                </MantineTooltip>
              </Box>
            </Box>

            {/* Tooltip et Menu pour afficher/cacher colonnes */}
            <Tooltip
              placement="top"
              isOpen={isButtonHovered}
              target="tooltipTop" // Utilisez l'ID du bouton de colonnes comme cible pour le tooltip
              toggle={() => {
                setIsButtonHovered(!isButtonHovered);
              }}
              style={{
                textAlign: "center",
                fontSize: "12px",
                backgroundColor: "black",
              }}
            >
              Afficher/Cacher colonnes
            </Tooltip>

            <Menu
              opened={isMenuOpen}
              onClickOutside={() => setIsMenuOpen(false)}
            >
              <Menu.Target>
                <Button
                  style={{
                    backgroundColor: "transparent",
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                    cursor: "pointer",
                  }}
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  <IconColumns id="tooltipTop" color="#868e96" />
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Label>Afficher/Cacher colonnes</Label>
                {headers.map((col, index) => (
                  <Menu.Item key={col.accessorKey} className="menu-container">
                    <Flex align="center" gap="xs">
                      <Switch
                        onChange={() => toggleColumnVisibility(index)}
                        checked={columnVisibility[index]}
                        onColor="#555B21"
                        offColor="#cccccc"
                        checkedIcon={false}
                        uncheckedIcon={false}
                        height={24}
                        width={48}
                        handleDiameter={24}
                      />
                      <span
                        style={{
                          marginLeft: "10px",
                          fontSize: "16px",
                          color: "#333",
                        }}
                        onClick={() => toggleColumnVisibility(index)}
                      >
                        {col.header}
                      </span>
                    </Flex>
                  </Menu.Item>
                ))}
              </Menu.Dropdown>
            </Menu>

            {/* Bouton Ajouter */}
            {allData?.can_add ? (
              <Link
                to={`${backUrl}/projets/new`}
                className="btn btn-sm btn-primary"
              >
                <i className="bx bx-plus"></i>Ajouter
              </Link>
            ) : // <Link
            //   to={`${backUrl}/projets/new`}
            //   className="btn btn-sm btn-info"
            // >
            //   <i className="bx bx-plus"></i>Ajouter
            // </Link>
            null}
            {allData?.can_export ? (
              <>
                <button
                  onClick={downloadFile}
                  className="btn btn-sm btn-primary"
                  disabled={loading2}
                >
                  <i className="mdi mdi-export-variant"></i>
                  {loading2 ? "Export En cours..." : "Exporter"}
                </button>
              </>
            ) : null}
            {downloadUrl && (
              <a
                href={downloadUrl}
                download={`export_projets_${new Date()
                  .toLocaleString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                  .replace(/[/: ]/g, "_")}.xlsx`}
                ref={downloadLinkRef}
                style={{ display: "none" }}
              >
                Télécharger le fichier Excel
              </a>
            )}
          </Flex>
        </Flex>
      </>
    ),

    renderRowActions: ({ row }) => (
      <Box
        style={{
          display: "flex",
          flexWrap: "nowrap",
          gap: "8px",
        }}
      >
        {allData?.can_show ? (
          <ActionIcon
            color="blue"
            component={Link}
            to={`${backUrl}/projets/${row.id}`}
            size={25}
          >
            <i className="mdi mdi-eye-outline"></i>
          </ActionIcon>
        ) : null}
        {allData?.can_edit ? (
          <ActionIcon
            color="orange"
            component={Link}
            to={`${backUrl}/projets/${row.id}/edit`}
            size={25}
          >
            <i className="mdi mdi-pencil-outline"></i>
          </ActionIcon>
        ) : null}
        {allData?.can_destroy ? (
          <ActionIcon color="red" size={25}>
            <DeleteButton
              url={`https://www.fluxod.com/${api}/projets/${row.id}`}
            />
          </ActionIcon>
        ) : null}
      </Box>
    ),
    enableHiding: false,
    enableColumnPinning: true,
    enableColumnActions: true,
    enableColumnFilters: false,
    enableFilterMatchHighlighting: true,
    enableSortingRemoval: false,
    enableStickyHeader: true,
    mantineTableContainerProps: { sx: { maxHeight: "500px" } },
    onColumnFiltersChange: isPageLoaded ? debouncedSetColumnFilters : null,
    onGlobalFilterChange: isPageLoaded ? setGlobalFilter : null,
    onPaginationChange: isPageLoaded ? setPagination : null,
    onSortingChange: setSorting,
    onColumnOrderChange: updateColumnOrder,
    onColumnPinningChange: handleColumnPinningChange,
    onColumnSizingChange: handleColumnSizingChange,
    state: {
      columnSizing,
      columnOrder,
      columnPinning,
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
    paginationDisplayMode: "pages",
    positionPagination: "none",
    enableGlobalFilter: false,
    mantineTableBodyCellProps: {
      style: {
        whiteSpace: "normal",
        fontSize: "12px",
        padding: 4,
      },
    },
    mantineSearchTextInputProps: {
      style: {
        color: "black",
      },
    },
    mantinePaginationProps: {
      style: {
        textDecorationColor: "black",
      },
    },
    mantineHighlightProps: {
      style: {
        fontSize: "12px",
        padding: "0",
      },
    },
    mantineLoadingOverlayProps: {
      style: { backgroundColor: "rgba(255, 165, 0, 0.2)" },
      loaderProps: { color: "#0a489b" },
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Error loading data" }
      : undefined,
  });
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath");

  /************************************** */
  return (
    <div className="page-content">
      {previousPath == `${backUrl}/projets/${lastId}/edit` ? (
        <LastModificationAlert path={"projets"} />
      ) : null}
      <MantineProvider
        theme={{
          components: {
            TextInput: {
              styles: (theme) => ({
                input: {
                  backgroundColor: layout === "dark" ? "#222736" : "#ffffff",
                  color: layout === "dark" ? "#e9ecef" : "#222736",
                  "&::placeholder": {
                    color: layout === "dark" ? "gray" : "darkgray",
                  },
                },
              }),
            },
            Select: {
              styles: (theme) => ({
                input: {
                  backgroundColor: layout === "dark" ? "#222736" : "#ffffff",
                  color: layout === "dark" ? "#e9ecef" : "#222736",
                  "&::placeholder": {
                    color: layout === "dark" ? "gray" : "darkgray",
                  },
                },
              }),
            },
          },
        }}
      >
        <MantineReactTable table={table} />
      </MantineProvider>
      <ToastContainer />
    </div>
  );
};

export default ProjetsList;
